import React, { useState } from "react";
import api from "../../api";
import { Paper, Grid, Button } from "@material-ui/core";
import UserCreateDialog from "./components/UserCreateDialog";

export default function User({ setIsLoading, setDataToast, userRole }) {
  const [createDialog, setCreateDialog] = useState(false);

  function shortMessage(text, type) {
    setDataToast({
      active: true,
      type: type ?? "error",
      message: text,
    });
  }

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>USUARIOS</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  className="c-grid-btn c-btn-success"
                  color="primary"
                  onClick={() => setCreateDialog(true)}
                >
                  Crear Nuevo
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {createDialog && (
        <UserCreateDialog
          Open={createDialog}
          Close={() => setCreateDialog(false)}
          SetIsLoading={setIsLoading}
          DisplayMessage={shortMessage}
          UserRole={userRole}
        />
      )}
    </>
  );
}
